import FullHeightPaper from '@fingo/lib/components/layout/FullHeightPaper';
import { REQUESTING_PLATFORM_TO_CODES } from '@fingo/lib/constants/requesting-platform';
import CredentialsUpdateFooter from '@fingo/lib/components/footers/CredentialsUpdateFooter';
import React from 'react';
import useGetUser from '@fingo/lib/hooks/useGetUser';
import { factoringTabs } from '../../../routes/sales';

const SalesSideFactoring = () => {
  const user = useGetUser();
  const tabs = factoringTabs();
  return (
    <>
      <FullHeightPaper tabs={tabs} useFingoWatermark scrollableTabs />
      {!user.selectedCompany?.hasSiiCredentials
      && <CredentialsUpdateFooter source={REQUESTING_PLATFORM_TO_CODES.ITAU} />}
    </>
  );
};

export default SalesSideFactoring;
